import { IGADataSchema } from 'shared/repositories/coworking/entities/ga_data/GADataSchema';

export const gaDataReducer = (state: IGADataSchema) => state || {};
